<template>
  <div
    v-if="criticalMessages && criticalMessages.length > 0 && isVisible"
    class="alert-notification-panel"
  >
    <div class="alert-notification-container">
      <div
        v-for="(message, i) in visibleCriticalMessages"
        :key="i"
        class="alert-notification-item position-relative bg-msg-critical border border-danger rounded mb-2 shadow-sm"
      >
        <!-- Per-item close button -->
        <button
          type="button"
          class="btn btn-sm btn-light border alert-item-close-button"
          aria-label="Close"
          @click="dismissMessage(message)"
        >
          <i class="fas fa-times"></i>
        </button>
        <div class="d-flex align-items-start p-3">
          <!-- Icon with background and border -->
          <div class="mr-3 mt-1">
            <div
              class="notification-icon-circle rounded-circle bg-white d-flex align-items-center justify-content-center"
              :class="getIconBorderColor(message)"
            >
              <i
                :class="`${getIconClass(message)} fa-lg notification-icon`"
              ></i>
            </div>
          </div>

          <!-- Content -->
          <div class="flex-grow-1 min-w-0">
            <div class="alert-message-body">
              <vue-editor
                class="reset-style editor-viewer font-weight-semibold"
                :disabled="true"
                :editor-options="editorOptions"
                v-model="message.previewBody"
              ></vue-editor>
            </div>
            <p class="mb-0 small text-muted mt-2">
              <i class="far fa-clock mr-1"></i
              >{{ message.sentAt ? getDateTime(message.sentAt) : '' }}
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { VueEditor } from 'vue2-editor'
import notificationsMixin from '~/mixins/notificationsMixin.js'

export default {
  components: {
    VueEditor,
  },
  mixins: [notificationsMixin],
  props: {
    criticalMessages: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      editorOptions: {
        modules: {
          toolbar: false,
        },
      },
      isVisible: false,
      dismissedMessageIds: [],
    }
  },
  computed: {
    visibleCriticalMessages() {
      if (!Array.isArray(this.criticalMessages)) return []
      return this.criticalMessages.filter(
        (msg) => !this.dismissedMessageIds.includes(msg?.id)
      )
    },
  },
  methods: {
    showModal() {
      this.dismissedMessageIds = []
      this.isVisible = true
    },
    dismissMessage(message) {
      const id = message?.id
      if (id === undefined || id === null) return
      if (!this.dismissedMessageIds.includes(id)) {
        this.dismissedMessageIds.push(id)
      }
      // If all items dismissed, hide panel
      if (this.visibleCriticalMessages.length === 0) {
        this.hideModal()
      }
    },
    hideModal() {
      this.isVisible = false
    },
    getDateTime(date) {
      return this.$dayjs.utc(date).local().format('L, LT')
    },
  },
}
</script>
<style lang="scss" scoped>
.alert-notification-panel {
  position: fixed;
  bottom: 20px;
  left: 50%;
  display: inline-block;
  width: auto;
  max-width: 90vw;
  max-height: 60vh;
  transform: translateX(-50%);
  z-index: 1050;
}

.alert-notification-container {
  display: block;
  width: 100%;
  max-width: 100%;
  max-height: 60vh;
  overflow-y: auto;
  overflow-x: hidden;
  padding: 10px;
}

.alert-notification-item {
  background-color: #f8d7da;
  transition: all 0.2s ease-in-out;
  width: max-content;
  max-width: 100%;
  margin-left: auto;
  margin-right: auto;
}

.alert-notification-item:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(220, 53, 69, 0.3) !important;
}

.notification-icon {
  line-height: 1;
}

.block-ui {
  position: fixed;
  top: 0;
  left: 0;
  width: 100svw !important;
  min-width: 100svw !important;
  height: 100svh !important;
  max-height: 100svh !important;
  z-index: 1040;
  background-color: rgba(0, 0, 0, 0.5);
}

:deep(.modal-content) {
  background-color: transparent !important;
}

:deep(.editor-viewer .ql-container) {
  border: none;
}

:deep(.editor-viewer .ql-container .ql-editor) {
  padding: 0;
  min-height: fit-content;
  white-space: normal;
  word-break: break-word;
  overflow-wrap: anywhere;
}

.editor-viewer {
  overflow-y: auto;
}

.alert-message-body {
  color: #721c24;
}

.alert-item-close-button {
  position: absolute;
  top: -10px;
  right: -10px;
  width: 28px;
  height: 28px;
  border-radius: 50%;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);
  z-index: 1;
}
</style>
